import React, { useState } from 'react';
import {
  Box,
  Tabs,
  Tab,
  Typography,
  Paper,
  Container
} from '@mui/material';
import {
  People,
  AttachMoney,
  Security,
  MonitorHeart,
  Analytics
} from '@mui/icons-material';

// Import existing admin dashboard
import AdminDashboard from '../AdminDashboard';

// Import new admin components
import SystemHealth from './SystemHealth';
import UserManagement from './UserManagement';
import CostManagement from './CostManagement';
import SecurityAudit from './SecurityAudit';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`admin-tabpanel-${index}`}
      aria-labelledby={`admin-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ py: 3 }}>
          {children}
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `admin-tab-${index}`,
    'aria-controls': `admin-tabpanel-${index}`,
  };
}

const EnhancedAdminDashboard = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (event, newValue) => {
    setCurrentTab(newValue);
  };

  const tabs = [
    {
      label: 'Usage Analytics',
      icon: <Analytics />,
      component: <AdminDashboard />
    },
    {
      label: 'System Health',
      icon: <MonitorHeart />,
      component: <SystemHealth />
    },
    {
      label: 'User Management',
      icon: <People />,
      component: <UserManagement />
    },
    {
      label: 'Cost Management',
      icon: <AttachMoney />,
      component: <CostManagement />
    },
    {
      label: 'Security & Audit',
      icon: <Security />,
      component: <SecurityAudit />
    }
  ];

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h4" component="h1" gutterBottom>
          Admin Dashboard
        </Typography>
      </Box>

      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs
            value={currentTab}
            onChange={handleTabChange}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="admin dashboard tabs"
          >
            {tabs.map((tab, index) => (
              <Tab
                key={index}
                icon={tab.icon}
                label={tab.label}
                iconPosition="start"
                {...a11yProps(index)}
                sx={{
                  minHeight: 64,
                  textTransform: 'none',
                  fontSize: '0.875rem',
                  fontWeight: 500
                }}
              />
            ))}
          </Tabs>
        </Box>

        {tabs.map((tab, index) => (
          <TabPanel key={index} value={currentTab} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </Paper>
    </Container>
  );
};

export default EnhancedAdminDashboard;
